export const clientHandlerOptions = [
  {
    name: 'ROLE_INFO',
    title: '用户身份级别信息',
    content:
      '用户身份级别信息包含 M1、M2、M3、RegionTMA、Region TM、SD、BUTM、BUTMD、SPAD、KAD、BUP、BCC、HQTM、HQTMD'
  },
  {
    name: 'NO_IDENTITY',
    title: '用户身份缺失',
    content:
      '您需要整理工号、姓名、身份级别信息，发送邮件到APAC服务邮箱给到运营进行补充<br />服务邮箱:apac.icircle@budwelserapac.com(工作日 8:00-17:00)'
  },
  {
    name: 'EMPTY_ORG',
    title: '默认组织架构信息缺失',
    content:
      '您需要整理工号、姓名、默认组织架构、身份级别信息，发送邮件到APAC服务邮箱给到运营进行补充<br />服务邮箱:apac.icircle@budwelserapac.com(工作日 8:00-17:00)'
  },
  {
    name: 'NO_MP_USER',
    title: '人员主数据缺失',
    content:
      '您需要整理工号、姓名、组织架构信息、默认组织架构身份级别信息，发送邮件到APAC服务邮箱给到运营进行补充<br />服务邮箱:apac.icircle@budwelserapac.com(工作日 8:00-17:00)'
  },
  {
    name: 'NO_MP_ORG',
    title: '组织架构信息缺失',
    content:
      '请您整理姓名、工号、真实组织架构信息，线下联系RTM在蜂火轮协助维护组织架构信息并抄送APAC服务邮箱维护，维护后预计2个工作日会同步到尊享先锋执行工具'
  },
  {
    name: 'NO_MP_POST',
    title: '岗位信息缺失',
    content:
      '请您整理姓名、工号、ABI岗位信息，线下联系RTM在蜂火轮协助维护组织架构信息并抄送APAC服务邮箱维护，维护后预计2个工作日会同步到尊享先锋执行工具'
  }
]